/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/
import RdKafkaCodeSnippet from './RdKafkaCodeSnippet';

export default class KafkacatKafkaCodeSnippet extends RdKafkaCodeSnippet {
  getBootstrapServers() {
    return this.apiHandler
      .getEndpoints()
      .map(({ url }) => url)
      .join(',');
  }
}
